import { initLogo3D } from "./logo3d";

// ========== LOADER ==========
export function initLoader() {
  window.addEventListener("load", () => {
    setTimeout(() => {
      document.querySelector(".loader")?.classList.add("loaded");
      document.body.style.overflow = "auto";
      initScrollAnimations();
    }, 800);
  });
}

// ========== CURSOR VIEW ==========
export function initCursor() {
  const cursor = document.querySelector(".cursor");

  if (!cursor || "ontouchstart" in window) {
    cursor?.remove();
    return;
  }

  let mouseX = 0,
    mouseY = 0;
  let cursorX = 0,
    cursorY = 0;

  document.addEventListener("mousemove", (e) => {
    mouseX = e.clientX;
    mouseY = e.clientY;
  });

  function animate() {
    cursorX += (mouseX - cursorX) * 0.15;
    cursorY += (mouseY - cursorY) * 0.15;
    cursor.style.left = cursorX + "px";
    cursor.style.top = cursorY + "px";
    requestAnimationFrame(animate);
  }
  animate();

  document.querySelectorAll(".product-card").forEach((card) => {
    card.addEventListener("mouseenter", () =>
      cursor.classList.add("cursor--product"),
    );
    card.addEventListener("mouseleave", () =>
      cursor.classList.remove("cursor--product"),
    );
  });
}
// ========== SCROLL ANIMATIONS ==========
export function initScrollAnimations() {
  const elements = document.querySelectorAll(
    "[data-scroll], .product-card, .shop-header, .product-details",
  );

  if (!elements.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry, index) => {
        if (entry.isIntersecting) {
          // Stagger animation
          setTimeout(() => {
            entry.target.classList.add("visible");
          }, index * 100);
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.1,
      rootMargin: "0px 0px -50px 0px",
    },
  );

  elements.forEach((el) => observer.observe(el));
}

// ========== SMOOTH SCROLL ==========
export function initSmoothScroll() {
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener("click", function (e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute("href"));
      if (target) {
        target.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    });
  });
}

// ========== SPLASH SCREEN ==========
export function initSplash() {
  const splash = document.getElementById("splashScreen");
  const button = document.getElementById("splashButton");

  if (!splash || !button) return;

  // Bloquear scroll mientras está activo
  document.body.style.overflow = "hidden";

  button.addEventListener("click", () => {
    splash.classList.add("hidden");
    document.body.style.overflow = "auto";

    // Opcional: guardar en sessionStorage para no mostrar de nuevo
    sessionStorage.setItem("splashSeen", "true");
  });
}

// Opcional: no mostrar si ya lo vio
export function checkSplash() {
  const splash = document.getElementById("splashScreen");
  if (splash && sessionStorage.getItem("splashSeen")) {
    splash.classList.add("hidden");
    document.body.style.overflow = "auto";
  }
}

// ========== VARIATION SWATCHES ==========
export function initVariationSwatches() {
  const selects = document.querySelectorAll(".variations select");

  selects.forEach((select) => {
    const wrapper = document.createElement("div");
    wrapper.className = "variation-buttons";

    Array.from(select.options).forEach((option) => {
      if (!option.value) return;

      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "variation-btn";
      btn.textContent = option.text;
      btn.dataset.value = option.value;

      btn.addEventListener("click", () => {
        // Actualizar select
        select.value = option.value;

        // Disparar evento con jQuery (WooCommerce lo necesita)
        if (window.jQuery) {
          jQuery(select).trigger("change");
        } else {
          select.dispatchEvent(new Event("change", { bubbles: true }));
        }

        // Actualizar estado activo
        wrapper
          .querySelectorAll(".variation-btn")
          .forEach((b) => b.classList.remove("active"));
        btn.classList.add("active");
      });

      wrapper.appendChild(btn);
    });

    select.style.display = "none";
    select.parentNode.appendChild(wrapper);

    // Escuchar cambios del select (por si WooCommerce lo resetea)
    jQuery(select).on("change", function () {
      const val = this.value;
      wrapper.querySelectorAll(".variation-btn").forEach((b) => {
        b.classList.toggle("active", b.dataset.value === val);
      });
    });

    // Reset
    const form = select.closest("form");
    if (form) {
      jQuery(form).on("reset click", ".reset_variations", function () {
        wrapper
          .querySelectorAll(".variation-btn")
          .forEach((b) => b.classList.remove("active"));
      });
    }
  });
}

export function initProductTilt() {
  document.querySelectorAll(".product-card").forEach((card) => {
    const image = card.querySelector(".product-image");
    if (!image) return;

    const imgs = image.querySelectorAll("img");

    card.addEventListener("mousemove", (e) => {
      const rect = card.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      const centerX = rect.width / 2;
      const centerY = rect.height / 2;

      const moveX = ((x - centerX) / centerX) * 15; // Max 15px
      const moveY = ((y - centerY) / centerY) * 15;

      imgs.forEach((img) => {
        img.style.transform = `translate(${moveX}px, ${moveY}px) scale(1.05)`;
      });
    });

    card.addEventListener("mouseleave", () => {
      imgs.forEach((img) => {
        img.style.transform = "translate(0, 0) scale(1)";
      });
    });
  });
}

export function initCarousel() {
  const slides = document.querySelectorAll(".carousel-slide");
  const bars = document.querySelectorAll(".progress-bar");
  if (!slides.length) return;

  let current = 0;
  const duration = 5000;

  function goTo(index) {
    slides[current].classList.remove("active");
    bars[current].classList.remove("active");
    bars[current].classList.add("done");

    current = index;

    bars.forEach((bar, i) => {
      if (i < current) bar.classList.add("done");
      else bar.classList.remove("done");
    });

    slides[current].classList.add("active");
    bars[current].classList.add("active");
  }

  function next() {
    goTo((current + 1) % slides.length);
  }

  let interval = setInterval(next, duration);

  bars.forEach((bar, i) => {
    bar.addEventListener("click", () => {
      clearInterval(interval);
      bars.forEach((b) => b.classList.remove("done", "active"));
      goTo(i);
      interval = setInterval(next, duration);
    });
  });
}

export function initContactCarousel() {
  const slides = document.querySelectorAll(".contact-slide");
  if (!slides.length) return;

  let current = 0;

  setInterval(() => {
    slides[current].classList.remove("active");
    current = (current + 1) % slides.length;
    slides[current].classList.add("active");
  }, 4000);
}

// ========== INIT ALL ==========
export function initShop() {
  initLoader();
  initCursor();
  initSmoothScroll();
  initSplash();
  checkSplash();
  initVariationSwatches();
  initProductTilt();
  initLogo3D();
  initCarousel();
  initContactCarousel();
}

document.querySelectorAll(".accordion-header").forEach((btn) => {
  btn.addEventListener("click", () => {
    btn.parentElement.classList.toggle("active");
  });
});

// Auto init
document.addEventListener("DOMContentLoaded", initShop);
